import { Injectable } from '@angular/core';
import { Headers, RequestOptions, } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { FormGroup } from '@angular/forms';

import { BUSINESSCONTACTS } from './../../model/register.model';
import { REGISTER } from 'app/model/register.model';
import { POSTTYPE } from 'app/model/post-type';
import {
    BUSINESSGROUP, DELIVERYMETHODARRAY, orgType, tenancyType, creditType
} from 'app/model/businessgroup.model';
import { OWNERINFO } from 'app/model/ownerinfo.model';
import { BUSINESSREF } from 'app/model/businessref.model';
import { FINANCIALGROUP } from 'app/model/financialgroup.model';
import { DECLARATIONGROUP } from 'app/model/declarationgroup.model';
import { GUARANTEEGROUP } from 'app/model/guaranteegroup.model';
import { MARKETINFO } from 'app/model/marketinfo.model';

// import { environment } from "../../../environments/environment"

@Injectable()
export class RegisterService {
    private registerObj: REGISTER;
    private posttype = new POSTTYPE();

    constructor(private http: HttpClient) { }

    submitform(
        registerform: FormGroup,
        reseller_accountcode: string = '',
        email: string = ''
    ) {
        // debugger;
        this.registerObj = registerform.value;
        // DONE:nothing in front

        this.posttype.cus_emailAddress = email;
        if (reseller_accountcode !== '') {
            this.posttype.in_reseller_accountcode = reseller_accountcode;
        } else {
            this.posttype.in_reseller_accountcode = '';
        }
        // DONE: here seperate each section into small functions
        this.submitBusiness(
            this.registerObj.businessGroup,
            this.registerObj.deliverMethodArray
        );
        this.submitContact(this.registerObj.businesscontacts);
        this.submitOwnerInfo(this.registerObj.ownerinfoArray);
        this.submitMarketInfo(this.registerObj.marketinfo);
        this.submitSupplier(this.registerObj.businessRefArray);
        this.submitFinancialGroup(this.registerObj.financialGroup);
        this.submitDeclaration(this.registerObj.declarationGroup);
        this.submitGuaranteeGroup(this.registerObj.guaranteeGroup);

        // PRIVACY ONLY 3 ITEMS SO NOT MOVE OUT
        this.posttype.in_mailing_email = this.registerObj.privacyGroup.in_mailing_email;
        this.posttype.in_read_and_understood = this.registerObj.privacyGroup
            .in_read_and_understood
            ? 'Y'
            : 'N';
        this.posttype.in_mailing_list =
            this.registerObj.privacyGroup.in_mailing_list_yes === true ? 'Y' : 'N';

        const header = new Headers();

        header.append('Content-Type', 'application/json');
        const options = new RequestOptions({
            headers: header
        });
        // http://localhost:52478/
        const url = 'api/values';

        // let url = 'http://localhost:55731/api/values';
        // FIXED: TODO:
        // http://localhost:52478 no need to use when together with .net
        // http://localhost:52478/api/values
        // this.http.post("Register/NewTest", JSON.stringify('hello'), options).subscribe(
        //    result =>

        return this.http.post(url, this.posttype);

        //  .subscribe(
        //   result => {
        //     console.log(result);
        //   },
        //   error => {
        //     console.log("has error: ", error);
        //   }
        // );
    }
    //   here
    submitMarketInfo(marketinfo: MARKETINFO) {
        // marketinfo.in_markets

        // {"CORP","SME","CONS","OEM","GOV","EDU","WEB","FIN","TELE" "OTH"}
        const in_market =
            (marketinfo.markets.in_markets_SME ? 'SME,' : '') +
            (marketinfo.markets.in_markets_CORP ? 'CORP,' : '') +
            (marketinfo.markets.in_markets_CONS ? 'CONS,' : '') +
            (marketinfo.markets.in_markets_OEM ? 'OEM,' : '') +
            (marketinfo.markets.in_markets_GOV ? 'GOV,' : '') +
            (marketinfo.markets.in_markets_EDU ? 'EDU,' : '') +
            (marketinfo.markets.in_markets_WEB ? 'WEB,' : '') +
            (marketinfo.markets.in_markets_FIN ? 'FIN,' : '') +
            (marketinfo.markets.in_markets_TELE ? 'TELE,' : '') +
            (marketinfo.markets.in_markets_OTH ? 'OTH' : '');
        // console.log(in_market);

        this.posttype.in_markets = in_market;
        // marketinfo.in_principal_products
        // {"OEM","PC","PERIPH","CONSUM","NET","INFRA","TELE","SOFT","CLOUD","SOL","SERV" "OTH"}
        const in2 =
            (marketinfo.products.in_principal_products_OEM ? 'OEM,' : '') +
            (marketinfo.products.in_principal_products_PC ? 'PC,' : '') +
            (marketinfo.products.in_principal_products_Peripherals ? 'PERIPH,' : '') +
            (marketinfo.products.in_principal_products_Consumables ? 'CONSUM,' : '') +
            (marketinfo.products.in_principal_products_Networking ? 'NET,' : '') +
            (marketinfo.products.in_principal_products_Infrastructure
                ? 'INFRA,'
                : '') +
            (marketinfo.products.in_principal_products_Telecommunications
                ? 'TELE,'
                : '') +
            (marketinfo.products.in_principal_products_Software ? 'SOFT,' : '') +
            (marketinfo.products.in_principal_products_Cloud ? 'CLOUD,' : '') +
            (marketinfo.products.in_principal_products_Solutions ? 'SOL,' : '') +
            (marketinfo.products.in_principal_products_Services ? 'SERV,' : '') +
            (marketinfo.products.in_principal_products_Other ? 'OTH' : '');

        this.posttype.in_principal_products = in2;

        this.posttype.in_other_market_desc = marketinfo.in_other_market_desc;
        this.posttype.in_other_product_desc = marketinfo.in_other_market_desc;

        switch (marketinfo.in_focus_size) {
            case '250':
                this.posttype.in_focus_size = '<250';
                break;
            case '2000':
                this.posttype.in_focus_size = '250-2000';
                break;
            default:
                this.posttype.in_focus_size = '2001';
                break;
        }

        // marketinfo.in_percent_annuity_based
        // : {"<25","25-50","50+"}

        switch (marketinfo.in_percent_annuity_based) {
            case '25%':
                this.posttype.in_percent_annuity_based = '<25';
                break;

            case '50%':
                this.posttype.in_percent_annuity_based = '25-50';
                break;

            default:
                this.posttype.in_percent_annuity_based = '51';
                break;
        }
    }
    submitGuaranteeGroup(guaranteeGroup: GUARANTEEGROUP) {
        this.posttype.in_guarantee_cust_name =
            guaranteeGroup.in_guarantee_cust_name;
        this.posttype.in_guarantor_name = guaranteeGroup.in_guarantor_name;
        this.posttype.in_guarantor_address1 = guaranteeGroup.in_guarantor_address1;
        this.posttype.in_guarantor_address2 = guaranteeGroup.in_guarantor_address2;
        this.posttype.in_guarantor_address3 = guaranteeGroup.in_guarantor_address3;
        this.posttype.in_guarantor_street = guaranteeGroup.in_guarantor_street;
        this.posttype.in_guarantor_suburb = guaranteeGroup.in_guarantor_suburb;
        this.posttype.in_guarantor_country =
            typeof guaranteeGroup.in_guarantor_country === 'undefined'
                ? ' '
                : guaranteeGroup.in_guarantor_country;
        this.posttype.in_guarantor_postcode = guaranteeGroup.in_guarantor_postcode;
        this.posttype.in_guarantor_sig_path = guaranteeGroup.in_guarantor_sig_path;
        this.posttype.in_guarantor_date = guaranteeGroup.in_guarantor_date;
        this.posttype.in_guarantor_abn = guaranteeGroup.in_guarantor_abn;
        this.posttype.in_witness_name = guaranteeGroup.in_witness_name;
        this.posttype.in_witness_address1 = guaranteeGroup.in_witness_address1;
        this.posttype.in_witness_address2 = guaranteeGroup.in_witness_address2;
        this.posttype.in_witness_address3 = guaranteeGroup.in_witness_address3;
        this.posttype.in_witness_street = guaranteeGroup.in_witness_street;
        this.posttype.in_witness_suburb = guaranteeGroup.in_witness_suburb;
        this.posttype.in_witness_country =
            typeof guaranteeGroup.in_witness_country === 'undefined'
                ? ' '
                : guaranteeGroup.in_witness_country;
        this.posttype.in_witness_postcode = guaranteeGroup.in_witness_postcode;
        this.posttype.in_witness_sig_path = guaranteeGroup.in_witness_sig_path;
        this.posttype.in_witness_date = guaranteeGroup.in_witness_date;

        this.posttype.in_doc_path = '';
    }

    //   TODO:here need to set the 3p value, but we do not need that
    submitContact(businesscontacts: BUSINESSCONTACTS) {
        this.posttype.in_manager_name = businesscontacts.in_manager_name;
        this.posttype.in_manager_email = businesscontacts.in_manager_email;
        this.posttype.in_manager_phone =
            businesscontacts.in_manager_phonecode +
            'sb' +
            businesscontacts.in_manager_phone;
        this.posttype.in_so_manager_name = businesscontacts.in_so_manager_name;
        this.posttype.in_so_manager_email = businesscontacts.in_so_manager_email;
        this.posttype.in_so_manager_phone =
            businesscontacts.in_so_manager_phonecode +
            'sb' +
            businesscontacts.in_so_manager_phone;
        this.posttype.in_po_manager_name = businesscontacts.in_po_manager_name;
        this.posttype.in_po_manager_email = businesscontacts.in_po_manager_email;
        this.posttype.in_po_manager_phone =
            businesscontacts.in_po_manager_phonecode +
            'sb' +
            businesscontacts.in_po_manager_phone;
        this.posttype.in_ap_manager_name = businesscontacts.in_ap_manager_name;
        this.posttype.in_ap_manager_email = businesscontacts.in_ap_manager_email;
        this.posttype.in_ap_manager_phone =
            businesscontacts.in_ap_manager_phonecode +
            'sb' +
            businesscontacts.in_ap_manager_phone;
        this.posttype.in_3p_manager_name = ' ';
        this.posttype.in_3p_manager_email = ' ';
        this.posttype.in_3p_manager_phone = ' ';
    }
    submitFinancialGroup(financialGroup: FINANCIALGROUP) {
        // this.posttype.FinancialDetails = "Financial Details"
        this.posttype.in_current_year_turnover =
            financialGroup.in_current_year_turnover;
        this.posttype.in_last_year_turnover = financialGroup.in_last_year_turnover;
        this.posttype.in_current_assets = financialGroup.in_current_assets;
        this.posttype.in_current_liabilities =
            financialGroup.in_current_liabilities;
        this.posttype.in_capital = financialGroup.in_capital;
        this.posttype.in_no_of_shares = financialGroup.in_no_of_shares;
        this.posttype.in_encumberance_charges =
            financialGroup.in_encumberance_charges;

        this.posttype.in_bankrupcy =
            financialGroup.in_bankrupcyYes === true ? 'Y' : 'N';
    }

    submitDeclaration(declarationGroup: DECLARATIONGROUP) {
        this.posttype.in_declare_name = declarationGroup.in_declare_name;
        this.posttype.in_declare_position = declarationGroup.in_declare_position;
        this.posttype.in_declare_path = declarationGroup.in_declare_path;
        this.posttype.in_declare_date = declarationGroup.in_declare_date;
    }

    submitSupplier(businessRefArray: BUSINESSREF[]) {
        // console.log("check:: ", businessRefArray.length, businessRefArray);

        this.posttype.in_supplier1_name = businessRefArray[0].in_supplier1_name;
        this.posttype.in_supplier1_contact =
            businessRefArray[0].in_supplier1_contact;
        this.posttype.in_supplier1_phone =
            businessRefArray[0].in_supplier1_phonecode +
            'sb' +
            businessRefArray[0].in_supplier1_phone;
        this.posttype.in_supplier1_email = businessRefArray[0].in_supplier1_email;

        if (businessRefArray.length > 1) {
            this.posttype.in_supplier2_name = businessRefArray[1].in_supplier1_name;
            this.posttype.in_supplier2_contact =
                businessRefArray[1].in_supplier1_contact;
            this.posttype.in_supplier2_phone =
                businessRefArray[1].in_supplier1_phonecode +
                'sb' +
                businessRefArray[1].in_supplier1_phone;
            this.posttype.in_supplier2_email = businessRefArray[1].in_supplier1_email;
        } else {
            this.posttype.in_supplier2_name = '';
            this.posttype.in_supplier2_contact = '';
            this.posttype.in_supplier2_phone = '';
            this.posttype.in_supplier2_email = '';
        }

        if (businessRefArray.length > 2) {
            this.posttype.in_supplier3_name = businessRefArray[2].in_supplier1_name;
            this.posttype.in_supplier3_contact =
                businessRefArray[2].in_supplier1_contact;
            this.posttype.in_supplier3_phone =
                businessRefArray[2].in_supplier1_phonecode +
                'sb' +
                businessRefArray[2].in_supplier1_phone;
            this.posttype.in_supplier3_email = businessRefArray[2].in_supplier1_email;
        } else {
            this.posttype.in_supplier3_name = '';
            this.posttype.in_supplier3_contact = '';
            this.posttype.in_supplier3_phone = '';
            this.posttype.in_supplier3_email = '';
        }
        if (businessRefArray.length > 3) {
            this.posttype.in_supplier4_name = businessRefArray[3].in_supplier1_name;
            this.posttype.in_supplier4_contact =
                businessRefArray[3].in_supplier1_contact;
            this.posttype.in_supplier4_phone =
                businessRefArray[3].in_supplier1_phonecode +
                'sb' +
                businessRefArray[3].in_supplier1_phone;
            this.posttype.in_supplier4_email = businessRefArray[3].in_supplier1_email;
        } else {
            this.posttype.in_supplier4_name = '';
            this.posttype.in_supplier4_contact = '';
            this.posttype.in_supplier4_phone = '';
            this.posttype.in_supplier4_email = '';
        }
    }

    submitOwnerInfo(ownerinfoArray: OWNERINFO[]) {
        // OWNER INFORMATION SECTION
        // this.posttype.OwnerInfo = "OwnerInfo"; //TODO now use hardcode for this, nor value pass from frontend
        this.posttype.in_director1_name = ownerinfoArray[0].in_director1_name;
        this.posttype.in_director1_dob = ownerinfoArray[0].in_director1_dob;

        this.posttype.in_director1_phone =
            ownerinfoArray[0].in_director1_phonecode +
            'sb' +
            ownerinfoArray[0].in_director1_phone;

        this.posttype.in_director1_address1 =
            ownerinfoArray[0].in_director1_address1;
        this.posttype.in_director1_address2 =
            ownerinfoArray[0].in_director1_address2;
        this.posttype.in_director1_address3 =
            ownerinfoArray[0].in_director1_address3;
        this.posttype.in_director1_street = ownerinfoArray[0].in_director1_street;
        this.posttype.in_director1_suburb = ownerinfoArray[0].in_director1_suburb;
        this.posttype.in_director1_country = ownerinfoArray[0].in_director1_country;
        this.posttype.in_director1_postcode =
            ownerinfoArray[0].in_director1_postcode;
        this.posttype.in_director1_licence_no =
            ownerinfoArray[0].in_director1_licence_no;

        if (ownerinfoArray.length > 1) {
            this.posttype.in_director2_name = ownerinfoArray[1].in_director1_name;
            this.posttype.in_director2_dob = ownerinfoArray[1].in_director1_dob;
            this.posttype.in_director2_phone =
                ownerinfoArray[1].in_director1_phonecode +
                'sb' +
                ownerinfoArray[1].in_director1_phone;
            this.posttype.in_director2_address1 =
                ownerinfoArray[1].in_director1_address1;
            this.posttype.in_director2_address2 =
                ownerinfoArray[1].in_director1_address2;
            this.posttype.in_director2_address3 =
                ownerinfoArray[1].in_director1_address3;
            this.posttype.in_director2_street = ownerinfoArray[1].in_director1_street;
            this.posttype.in_director2_suburb = ownerinfoArray[1].in_director1_suburb;
            this.posttype.in_director2_country =
                ownerinfoArray[1].in_director1_country;
            this.posttype.in_director2_postcode =
                ownerinfoArray[1].in_director1_postcode;
            this.posttype.in_director2_licence_no =
                ownerinfoArray[1].in_director1_licence_no;
        } else {
            this.posttype.in_director2_name = '';
            this.posttype.in_director2_dob = '';
            this.posttype.in_director2_phone = '';
            this.posttype.in_director2_address1 = '';
            this.posttype.in_director2_address2 = '';
            this.posttype.in_director2_address3 = '';
            this.posttype.in_director2_street = '';
            this.posttype.in_director2_suburb = '';
            this.posttype.in_director2_country = '';
            this.posttype.in_director2_postcode = '';
            this.posttype.in_director2_licence_no = '';
        }
        if (ownerinfoArray.length > 2) {
            this.posttype.in_director3_name = ownerinfoArray[2].in_director1_name;
            this.posttype.in_director3_dob = ownerinfoArray[2].in_director1_dob;
            this.posttype.in_director3_phone =
                ownerinfoArray[2].in_director1_phonecode +
                'sb' +
                ownerinfoArray[2].in_director1_phone;
            this.posttype.in_director3_address1 =
                ownerinfoArray[2].in_director1_address1;
            this.posttype.in_director3_address2 =
                ownerinfoArray[2].in_director1_address2;
            this.posttype.in_director3_address3 =
                ownerinfoArray[2].in_director1_address3;
            this.posttype.in_director3_street = ownerinfoArray[2].in_director1_street;
            this.posttype.in_director3_suburb = ownerinfoArray[2].in_director1_suburb;
            this.posttype.in_director3_country =
                ownerinfoArray[2].in_director1_country;
            this.posttype.in_director3_postcode =
                ownerinfoArray[2].in_director1_postcode;
            this.posttype.in_director3_licence_no =
                ownerinfoArray[2].in_director1_licence_no;
        } else {
            this.posttype.in_director3_name = '';
            this.posttype.in_director3_dob = '';
            this.posttype.in_director3_phone = '';
            this.posttype.in_director3_address1 = '';
            this.posttype.in_director3_address2 = '';
            this.posttype.in_director3_address3 = '';
            this.posttype.in_director3_street = '';
            this.posttype.in_director3_suburb = '';
            this.posttype.in_director3_country = '';
            this.posttype.in_director3_postcode = '';
            this.posttype.in_director3_licence_no = '';
        }
    }
    submitBusiness(
        businessGroup: BUSINESSGROUP,
        deliverMethodArray: DELIVERYMETHODARRAY[]
    ): any {
        this.posttype.in_org_type = orgType.get(businessGroup.in_org_type.trim());
        this.posttype.in_customer_name = businessGroup.in_customer_name;
        this.posttype.in_entity_name = businessGroup.in_entity_name;
        this.posttype.in_trust_name = businessGroup.in_trust_name;
        this.posttype.in_ABN = businessGroup.in_ABN;
        this.posttype.in_ACN = businessGroup.in_ACN;
        this.posttype.in_RequestLimitCredit = businessGroup.in_RequestLimitCredit;
        //
        this.posttype.in_date_business_started =
            businessGroup.in_date_business_started;
        this.posttype.in_date_business_purchased =
            businessGroup.in_date_business_purchased;
        this.posttype.in_estimated_monthly_purch =
            businessGroup.in_estimated_monthly_purch;
        this.posttype.in_bank_contact = businessGroup.in_bank_contact;
        this.posttype.in_bank_address1 = businessGroup.in_bank_address1;
        this.posttype.in_bank_address2 = businessGroup.in_bank_address2;
        this.posttype.in_bank_address3 = businessGroup.in_bank_address3;
        this.posttype.in_swift_address = businessGroup.in_swift_address;
        this.posttype.in_bank_account_name = businessGroup.in_bank_account_name;
        this.posttype.in_bsb = businessGroup.in_bsb;
        this.posttype.in_account_number = businessGroup.in_account_number;
        this.posttype.in_incorporation_date = businessGroup.in_incorporation_date;
        this.posttype.in_incorporation_place = businessGroup.in_incorporation_place;
        this.posttype.in_company_address1 = businessGroup.in_company_address1;
        this.posttype.in_company_address2 = businessGroup.in_company_address2;
        this.posttype.in_company_address3 = businessGroup.in_company_address3;
        this.posttype.in_company_street = businessGroup.in_company_street;
        this.posttype.in_company_suburb = businessGroup.in_company_suburb;

        this.posttype.in_company_country =
            typeof businessGroup.in_company_country === 'undefined'
                ? ' '
                : businessGroup.in_company_country;

        this.posttype.in_company_postcode = businessGroup.in_company_postcode;
        this.posttype.in_parent_company = businessGroup.in_parent_company;

        this.posttype.in_delivery_address1 = businessGroup.in_delivery_address1;
        this.posttype.in_delivery_address2 = businessGroup.in_delivery_address2;
        this.posttype.in_delivery_address3 = businessGroup.in_delivery_address3;
        this.posttype.in_tenancy = tenancyType.get(businessGroup.in_tenancy.trim());

        this.posttype.in_time_at_address = businessGroup.in_time_at_address;
        this.posttype.in_email = businessGroup.in_email;
        this.posttype.in_phone = (
            businessGroup.in_phonecode +
            'sb' +
            businessGroup.in_phone
        ).trim();
        this.posttype.in_fax = businessGroup.in_fax;
        this.posttype.in_company_website_url = businessGroup.in_company_website_url;

        this.posttype.in_required_credit = creditType.get(
            businessGroup.in_required_credit.trim()
        );
        console.log(
            'business group credis: ',
            businessGroup.in_required_credit.trim()
        );
        this.posttype.in_online_contact = businessGroup.in_online_contact;
        this.posttype.in_admin_email = businessGroup.in_admin_email;
        this.posttype.in_password = businessGroup.in_password;

        this.posttype.in_part_ship =
            businessGroup.in_part_ship === 'No Part Ship' ? 'N' : 'Y';

        // this.posttype.in_part_ship = "Y"

        this.posttype.in_delivery_street = businessGroup.in_delivery_street;
        this.posttype.in_delivery_suburb = businessGroup.in_delivery_suburb;
        this.posttype.in_delivery_country = businessGroup.in_delivery_country;
        this.posttype.in_delivery_postcode = businessGroup.in_delivery_postcode;
        // deliverMethodArray from this array
    }
}



// WEBPACK FOOTER //
// ./src/app/services/register/register.service.ts